export const getPlans = (
    state,
    plans
) => {
    state.plans = plans;
};

export const getPlanSummary = (state, summary) => {
    state.planSummary = summary
}

export const addPlan = (state, plan) => {
    state.plans = {...state.plans, plan}
}

export const subscibe = (
    state, subscibe
) => {
    state.subscibe = subscibe;
}

export const fetchPlanUser = (state, userPlans) => {
    state.userPlan = userPlans
}

export const updatePlan = (
    state, plan
) => {
    const planIdx = state.plans.findIndex(
        (_plan) => _plan.id === plan.id
    );

    if (planIdx < 0) {
        return;
    }

    state.plans[planIdx] = plan;
}

export const deletePlan = (
    state, planId
) => {
    const plans = state.plans.filter(
        (_plan) => _plan.id === planId
    );

    state.plans = plans;
}

export const updatePlanCoinType = (
    state, coinType
) => {

    const planIdx = state.plans.findIndex(
        (_plan) => _plan.id === coinType.planId
    );

    if (planIdx < 0) {
        return;
    }

    const foundPlan = state.plans[planIdx];

    foundPlan.coin_types = {
        ...foundPlan.coin_types,
        coinType
    }
}

export const removePlanCoinType = (
    state, coinType
) => {

    const planIdx = state.plans.findIndex(
        (_plan) => _plan.id === coinType.planId
    );

    if (planIdx < 0) {
        return;
    }

    const foundPlan = state.plans[planIdx];

    const new_coin_types = foundPlan.coin_types.filter(
        (_coin_types) => _coin_types.id !== coinType.coinTypeId
    );

    foundPlan.coin_types = new_coin_types
}

// export const attachCoinType = (
//   state, subscibe
// ) => {
//   state.subscibe = subscibe;
// }

// export const detachCoinType = (
//   state, subscibe
// ) => {
//   state.subscibe = subscibe;
// }

export const confirmLoan = (state, userPlanId) => {
    state.userPlan.data = state.userPlan.data.map(userPlan => userPlan.id === userPlanId ? ({...userPlan, status: "ACTIVE"}) : userPlan)
}

export const terminatePlan = (state, userPlanId) => {
    state.userPlan.data = state.userPlan.data.map(userPlan => userPlan.id === userPlanId ? ({...userPlan, status: "DECLINED"}) : userPlan)
}

export const planConfigBulk = (state, data = []) => {
    const plan_id = data[0].plan_id
    const planIdx = state.plans.findIndex(
        (_plan) => _plan.id === plan_id
    );

    if (planIdx < 0) {
        return;
    }

    const plan = state.plans[planIdx];
    const { configs = []} = plan;
    const configById = {};
    for (let index = 0; index < configs.length; index++) {
        const config = configs[index];
        configById[config.id] = config
    }
    plan.config = data.map(c => c.id && Object.keys(configById).includes(c.id) ? ({...c, ...configById[c.id]}) : c)

    state.plans[planIdx] = plan;
}

const PlanMutation = {
    getPlans,
    addPlan,
    updatePlan,
    deletePlan,
    subscibe,
    updatePlanCoinType,
    removePlanCoinType,
    fetchPlanUser,
    getPlanSummary,
    confirmLoan,
    terminatePlan,
    planConfigBulk
    // attachCoinType, 
    // detachCoinType
};

export default PlanMutation;